export const layerDialogStyles = {
    tabs: {
        height: 376,
    },
    tabBar: {
        borderBottom: '1px solid #ddd',
    },
    select: {
        width: 'auto',
        maxWidth: 300,
    },
    flexColumnFlow: {
        display: 'flex',
        flexFlow: 'column',
        maxHeight: 320,
        overflowY: 'auto',
        paddingBottom: 16,
    },
    flexRowFlow: {
        display: 'flex',
        flexFlow: 'row wrap',
        margin: '4px -12px 0',
    },
    flexItem: {},
    flex: {
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'space-between',
        alignContent: 'flex-start',
        margin: '4px -12px 0',
    },
    flexRow: {
        flex: '100%',
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'space-between',
        alignContent: 'flex-start',
    },
    flexColumn: {
        flex: '50%',
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'space-between',
        alignContent: 'flex-start',
        boxSizing: 'border-box',
    },
    flexFull: {
        flex: '100%',
        boxSizing: 'border-box',
        borderLeft: '12px solid #fff',
        borderRight: '12px solid #fff',
    },
    flexFullMax: {
        maxWidth: 400,
        flex: '100%',
        boxSizing: 'border-box',
        borderLeft: '12px solid #fff',
        borderRight: '12px solid #fff',
    },

    flexHalf: {
        // flex: '50%',
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: 20,
        boxSizing: 'border-box',
        borderLeft: '12px solid #fff',
        borderRight: '12px solid #fff',
        overflow: 'auto',
    },
    flexThird: {
        maxWidth: 280,
        flex: '33%',
        boxSizing: 'border-box',
        borderLeft: '12px solid #fff',
        borderRight: '12px solid #fff',
    },
    flexQuarter: {
        flex: '25%',
        boxSizing: 'border-box',
        borderLeft: '12px solid #fff',
        borderRight: '12px solid #fff',
    },
};



// WEBPACK FOOTER //
// ./src/components/edit/LayerDialogStyles.js